import * as React from 'react';
import DialogView from './Dialog.view';

export interface DialogProps {
  open: boolean,
  handleClose?: any,
  title: string,
  content?: string,
  onLeftArrowClick?: any,
  onRightArrowClick?: any,
  isComponent?:any,
  component?:any
}

const Dialog: React.FC<DialogProps> = (props: any) => {
  return <DialogView {...props} />;
}

export default Dialog;